import React, { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// Extend with any other app environments needed.

var AppNameContext = /*#__PURE__*/createContext('other');
function AppNameContextProvider(_ref) {
  var appName = _ref.appName,
    children = _ref.children;
  return /*#__PURE__*/_jsx(AppNameContext.Provider, {
    value: appName,
    children: children
  });
}
function useAppNameContext() {
  return useContext(AppNameContext);
}
export { AppNameContextProvider, useAppNameContext };